<template>
  <button
    type="button"
    :class="{
            'volume-button': true,
            'on': !isMute
          }"
    @click="toggleMute"
  >
    <span class="a11y-hidden">볼륨 켜기</span>
  </button>
</template>

<script>
import { PlayerInterface } from '@/common/utils/player.interface'

/**
 * 트레일러 플레이어 음소거 해제 버튼
 */
export default {
  name: 'BtnToggleMuteTrailer',
  props: {
    contentInfo: {
      type: Object
    }
  },
  data () {
    return {
      isMute: true
    }
  },
  methods: {
    /**
     * 음소거
     */
    toggleMute () {
      this.isMute = !this.isMute
      return PlayerInterface.setMute(this.isMute)
    }
  },
  watch: {
    contentInfo () {
      this.isMute = true
      return PlayerInterface.setMute(this.isMute)
    }
  }
}
</script>

<style scoped>

</style>
